var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48225 1.46937C-1.50821e-07 2.93886 0 5.30396 0 10.0342V15.0513C0 19.7815 -1.50821e-07 22.1467 1.48225 23.6161C2.96451 25.0857 5.35015 25.0857 10.1215 25.0857H12.6518C17.4231 25.0857 19.8088 25.0857 21.291 23.6161C22.7733 22.1467 22.7733 19.7815 22.7733 15.0513V10.0342C22.7733 5.30396 22.7733 2.93886 21.291 1.46937C19.8088 -0.000121921 17.4231 -0.00012207 12.6518 -0.00012207H10.1215C5.35015 -0.00012207 2.96451 -0.000121921 1.48225 1.46937ZM5.37702 7.52561C5.37702 7.00607 5.80186 6.58489 6.32591 6.58489H16.4474C16.9714 6.58489 17.3963 7.00607 17.3963 7.52561C17.3963 8.04515 16.9714 8.46633 16.4474 8.46633H6.32591C5.80186 8.46633 5.37702 8.04515 5.37702 7.52561ZM5.37702 12.5428C5.37702 12.0232 5.80186 11.6021 6.32591 11.6021H16.4474C16.9714 11.6021 17.3963 12.0232 17.3963 12.5428C17.3963 13.0623 16.9714 13.4835 16.4474 13.4835H6.32591C5.80186 13.4835 5.37702 13.0623 5.37702 12.5428ZM6.32591 16.6192C5.80186 16.6192 5.37702 17.0404 5.37702 17.5599C5.37702 18.0794 5.80186 18.5006 6.32591 18.5006H12.6518C13.1759 18.5006 13.6007 18.0794 13.6007 17.5599C13.6007 17.0404 13.1759 16.6192 12.6518 16.6192H6.32591Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5005 19.0684C24.5005 23.1686 21.1465 26.4998 17.0002 26.4998C12.8539 26.4998 9.5 23.1686 9.5 19.0684C9.5 14.9683 12.8539 11.6371 17.0002 11.6371C21.1465 11.6371 24.5005 14.9683 24.5005 19.0684Z",
    fill: "black",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.1987L20.5197 23.1566",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4794 21.1986C18.3385 21.1986 19.8455 19.7376 19.8455 17.9354C19.8455 16.1332 18.3385 14.6722 16.4794 14.6722C14.6203 14.6722 13.1133 16.1332 13.1133 17.9354C13.1133 19.7376 14.6203 21.1986 16.4794 21.1986Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogWhite);
export default __webpack_public_path__ + "static/media/logWhite.6ce85f66fd6ff060af8a7f7ed508ecf7.svg";
export { ForwardRef as ReactComponent };